goog.provide("shadow.js.shim.module$src$svg$inform$cross_square_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$cross_square_svg");
shadow.js.shim.module$src$svg$inform$cross_square_svg = shadow.js.nativeProvides["src/svg/inform/cross-square.svg"] = shadow$bridge("src/svg/inform/cross-square.svg");
module$shadow_js_shim_module$src$svg$inform$cross_square_svg.default = shadow.js.shim.module$src$svg$inform$cross_square_svg;
